export const HMapOperations = {
  NewRecord: 'NewRecord',
  EditRecord: 'EditRecord',
  ReadOnlyRecord: 'ReadOnlyRecord'
}
